import { render, staticRenderFns } from "./platdealdetail-add-or-update.vue?vue&type=template&id=13fb8ce4&"
import script from "./platdealdetail-add-or-update.vue?vue&type=script&lang=js&"
export * from "./platdealdetail-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports